module.exports = __webpack_public_path__ + "img/returnHome.c0c28d8c.png";